var _path, _path2, _path3, _path4, _g, _path5, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNoJob = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 160,
    viewBox: "0 0 219 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.167 0H112.23V15.9575H113.167V0Z",
    fill: "#333335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.665 35.2641H134.407C134.407 35.2641 130.369 15.9648 112.206 15.9648C96.0466 15.9648 90.665 35.2641 90.665 35.2641Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.999 0H111.332V15.9575H113.999V0Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6542 85.0997L64.8141 151.063L63.1328 159.699L148.856 159.285C152.701 159.267 156.118 155.853 157.349 150.78L172.568 88.4995C173.509 84.6498 171.446 80.6441 168.526 80.6477L81.7648 80.7384C79.833 80.742 78.1553 82.5272 77.6542 85.0997Z",
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6542 85.0997L64.8141 151.063L63.1328 159.699L148.856 159.285C152.701 159.267 156.118 155.853 157.349 150.78L172.568 88.4995C173.509 84.6498 171.446 80.6441 168.526 80.6477L81.7648 80.7384C79.833 80.742 78.1553 82.5272 77.6542 85.0997Z",
    fill: "#7E7E80"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.631 146.586L131.553 73.5069C131.19 70.5135 128.793 68.2785 125.975 68.2893L106.073 68.351C105.334 68.3598 104.604 68.5188 103.929 68.8182C103.253 69.1176 102.646 69.5512 102.144 70.0926L92.7023 80.1323L37.3546 80.419C33.9703 80.4371 31.374 83.6373 31.8206 87.2294L40.2488 154.771C40.6119 157.761 43.0012 159.993 45.8191 159.989L142.28 159.797C153.025 160.018 154.049 156.85 154.049 156.85C141.732 159.586 140.635 146.604 140.631 146.586Z",
    fill: "#E6E6E6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0388 131.971L95.7852 135.461L70.7295 112.936L73.9831 109.446L99.0388 131.971Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4236 108.673L98.0185 111.906L75.3449 136.234L71.75 133.001L94.4236 108.673Z",
    fill: "#D1D1D1"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoJob, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no-job.813cce33.svg";
export { ForwardRef as ReactComponent };